import {useNavigate} from 'react-router'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import {useSchoolAdmin} from '@freckle/school/ts/hooks/use-school-admin'
import type {SharedTableParamsT} from '@freckle/school/ts/manage-teachers/components/api-controlled-table'
import {ManageTeachers} from './'
import type {TabKeyT} from './utils'

export type QueryParamsProps = {
  schoolIds: Array<number> | undefined | null
  activeTab: TabKeyT | undefined | null
  tableParams: SharedTableParamsT
}

type Props = {
  schools: Array<SchoolAttrs>
} & QueryParamsProps

export function ManageTeachersContainer(props: Props) {
  const {schoolIds, activeTab, tableParams, schools} = props
  const navigate = useNavigate()

  const schoolAdmin = useSchoolAdmin()

  return (
    <WithResources
      resources={{schoolAdmin}}
      render={({schoolAdmin}) => (
        <ManageTeachers
          schools={schools}
          currentSchoolIds={schoolIds}
          schoolAdmin={schoolAdmin}
          routerHistory={navigate}
          activeTab={activeTab}
          tableParams={tableParams}
        />
      )}
    />
  )
}
